import React, { useEffect, useState } from 'react';
import { useParams, Link, useLocation, useNavigate } from 'react-router-dom';
import api from '../../utils/api';
import HorseGallery from '../../components/horseDetails/HorseGallery';
import HorseMetadata from '../../components/horseDetails/HorseMetadata';
import HorseDocuments from '../../components/horseDetails/HorseDocuments';
import HorsePedigree from '../../components/horseDetails/HorsePedigree';
import HorseTraining from '../../components/horseDetails/HorseTraining';
import HorseHealth from '../../components/horseDetails/HorseHealth';
import HorseSeller from '../../components/horseDetails/HorseSeller';

export default function HorseProfile() {
  const { id } = useParams();
  const location = useLocation();
  const [horse, setHorse] = useState(null);

  useEffect(() => {
    const fetchHorse = async () => {
      try {
        const res = await api.get(`/horses/${id}`);
        setHorse(res.data);
      } catch (err) {
        console.error('Failed to fetch horse details:', err);
      }
    };

    fetchHorse();
  }, [id]);

  if (!horse) return <p className="text-center">Loading horse details...</p>;

     // Determine back link
  const fromSearch = location.state?.fromSearch === true;
  const fromTab = location.state?.fromTab || 'dashboard';
  const fromProfile = location.state?.fromProfile === true;

  const backLink = fromSearch
  ? '/search'
  : fromProfile
  ? '/profile'
  : `/dashboard#${fromTab}`;


  const {
    horseInfo = {},
    saleInfo = {},
    healthInfo = {},
    documents = [],
    owner,
    status
  } = horse;

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-6 space-y-6">
      <Link to={backLink} className="inline-block px-4 py-2 text-sm bg-primary text-montserrat text-white rounded shadow"> ← {fromSearch ? 'Back to Search Results' : fromProfile ? 'Back to Profile' : 'Back to Dashboard'}</Link>

      <h1 className="text-5xl font-medium text-center font-cormorant text-primary">{horseInfo.name}</h1>

      {/* 📸 Gallery */}
      <HorseGallery images={horseInfo.images} />

      {/* 📊 Metadata Section */}
      <HorseMetadata horse={horse} />

      {/* 🏇 Training Section */}
      <HorseTraining
        training={horseInfo.traininglevel}
        disciplines={horseInfo.disciplines}
        temperament={horseInfo.temperament}
      />

      {/* 🏥 Health Section */}
      <HorseHealth health={healthInfo} />

      {/* 🧬 Pedigree Section */}
      <HorsePedigree pedigree={horseInfo.pedigree} />

       {/* 📄 Documents Section */}
       <HorseDocuments status={status} documents={documents} />

      {/* 👤 Seller Section */}
      <HorseSeller seller={owner} />

     
    </div>
  );
}